export const iconCloseButtonStyle = theme => ({
  root: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2) + 2,
    color: theme.palette.grey[500],
    width: theme.spacing(10),
    height: theme.spacing(10),
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
      color: theme.palette.grey[600],
      '@media (hover: none)': {
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.grey[50]
      }
    },
    '&$disabled': {
      backgroundColor: 'transparent',
      color: theme.palette.grey[300]
    },
    '&$label': {
      width: 10,
      height: 10
    }
  }
})
